var _excluded = ["className", "clickableAttribute", "disabled", "error", "id", "inputClassName", "inputRef", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "name", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useMemo } from 'react';
import classnames from 'classnames';
import FieldError from "../FieldError";
import { Tick } from "../Icon";
import Text from "../Text";
import { dataAndRest, specificDataAndRest } from "../../utils";
import StyledCheckbox, { StyledCheckboxAppearance, StyledCheckboxInput, StyledCheckboxLabel } from "./styled";
import { useTheme } from 'styled-components';
import BackgroundProvider from "../BackgroundProvider";

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/checkbox)
 **/
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    clickableAttribute = _ref.clickableAttribute,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    id = _ref.id,
    inputClassName = _ref.inputClassName,
    inputRef = _ref.inputRef,
    _ref$isAssertiveError = _ref.isAssertiveError,
    isAssertiveError = _ref$isAssertiveError === void 0 ? false : _ref$isAssertiveError,
    label = _ref.label,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '03' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme() || {};
  var classNames = useMemo(function () {
    return classnames('csl-checkbox', className);
  }, [className]);
  var _useMemo = useMemo(function () {
      return specificDataAndRest(rest, clickableAttribute);
    }, [rest, clickableAttribute]),
    _useMemo2 = _slicedToArray(_useMemo, 1),
    clickableAttributes = _useMemo2[0];
  var _useMemo3 = useMemo(function () {
      return dataAndRest(rest);
    }, [rest]),
    _useMemo4 = _slicedToArray(_useMemo3, 2),
    dataAttributes = _useMemo4[0],
    inputAttributes = _useMemo4[1];
  var inputClassNames = useMemo(function () {
    return classnames('csl-checkbox__input', inputClassName);
  }, [inputClassName]);
  var labelClassName = useMemo(function () {
    return classnames('csl-checkbox__label', {
      'csl-checkbox__label--disabled': disabled
    });
  }, [disabled]);
  return /*#__PURE__*/React.createElement(StyledCheckbox, _extends({
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $marginRight: marginRight,
    $marginTop: marginTop
  }, dataAttributes, {
    className: classNames,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    id: "".concat(name, "-error")
  }, typeof error === 'string' && /*#__PURE__*/React.createElement(FieldError, {
    isAssertive: isAssertiveError
  }, error)), /*#__PURE__*/React.createElement(StyledCheckboxLabel, {
    $disabled: disabled,
    htmlFor: name,
    className: labelClassName
  }, /*#__PURE__*/React.createElement(StyledCheckboxInput, _extends({
    "aria-describedby": "".concat(name, "-error")
  }, inputAttributes, clickableAttributes, {
    "aria-invalid": Boolean(error),
    className: inputClassNames,
    disabled: disabled,
    id: id || name,
    ref: inputRef,
    name: name,
    onChange: onChange,
    type: "checkbox"
  })), /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.color_input_background_default
    }
  }, /*#__PURE__*/React.createElement(StyledCheckboxAppearance, {
    className: "csl-checkbox__appearance"
  }, /*#__PURE__*/React.createElement(Tick, {
    color: "inherit",
    iconSize: "lg",
    size: "s1"
  }))), /*#__PURE__*/React.createElement(Text, {
    color: disabled ? 'subdued' : 'normal',
    size: "s2",
    weight: "normal"
  }, label)));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;
export { StyledCheckbox, StyledCheckboxAppearance, StyledCheckboxInput, StyledCheckboxLabel };